export const StorageKeys = {
  accessToken: 'pac',
  redirectUrl: 'redirectUrl',
  currentLanguage: 'currentLanguage',
  selectedOrganization: 'selectedOrganization',
  selectedUserRole: 'selectedUserRole',
  customerProfile: 'customerProfile',
  languages: 'languages',
} as const;
